export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40439de3ae6efbc4e7fcc5d7af0745c8aa699f0c02&name=revalidateCommunity!'